export default __webpack_public_path__ + "static/media/order-report.1c6aaebc.svg";